import * as React from 'react';
import { sortBy } from 'lodash';

import { Grid, Cell, Button, Icon, PopupTooltip } from '@teamsnap/teamsnap-ui';

import './select-division-attributes.scss';

export const buildCheckboxName = (tag: any, attributeName: string) => `${attributeName}.${tag.id}`;

interface DivisionAttributeProps {
  attributeTags: any[];
  title: string;
  attributeName: string;
  seasonForm: any;
  tooltip?: any;
}

const SelectDivisionAttribute: React.FunctionComponent<DivisionAttributeProps> = ({
  attributeTags,
  title,
  attributeName,
  seasonForm,
  tooltip,
}) => {
  if (attributeTags.length < 1) {
    return null;
  }

  const { register, setValue, watch } = seasonForm;

  const checkboxNames = attributeTags.map((tag) => buildCheckboxName(tag, attributeName));

  const updateAll = (value) => {
    checkboxNames.forEach((field) => setValue([{ [field]: value }]));
  };

  const selectAll = () => {
    updateAll(true);
  };
  const deselectAll = () => {
    updateAll(false);
  };

  const values = watch(attributeName) || {};
  const selectedNames = Object.entries(values)
    .filter(([_, value]) => value !== false)
    .map(([k, _]) => k);

  const allSelected = selectedNames.length === checkboxNames.length;
  const selectText = allSelected ? 'Clear All' : 'Select All';
  const selectFunction = allSelected ? deselectAll : selectAll;
  const sortedAttributes = sortBy(attributeTags, (tag) => tag.id);

  return (
    <div className="select-division-attributes">
      <div className="FieldGroup-label u-padTopMd u-padBottomSm u-flex">
        <div className="u-displayFlex u-flexAlignItemsCenter">
          <span>{title}</span>
          {tooltip && (
            <PopupTooltip text={tooltip}>
              <Icon mods="u-spaceLeftXs u-colorPrimary5" name="info" />
            </PopupTooltip>
          )}
        </div>
        <Button type="link" className="u-sizeFill u-flexAlignSelfEnd u-textRight" onClick={selectFunction}>
          {selectText}
        </Button>
      </div>

      <Grid isWithGutter={true}>
        {sortedAttributes.map((tag) => (
          <Cell key={tag.id} mods="u-size6of12">
            <div key={tag.id} className="Checkbox Checkbox--pill">
              <input
                className="Checkbox-input"
                type="checkbox"
                name={buildCheckboxName(tag, attributeName)}
                id={tag.id}
                value={tag.id}
                ref={register}
                defaultChecked={false}
              />
              <label className="Checkbox-label" htmlFor={tag.id}>
                {tag.name}
                {tag.isArchived && ' (Archived)'}
              </label>
            </div>
          </Cell>
        ))}
      </Grid>
    </div>
  );
};

export default SelectDivisionAttribute;
